import Header from '../../components/Header'
import HeaderImage from '../../images/header_bg_5.jpg'


import './trainers.css';
import { useEffect, useState } from 'react';
import { Card, CardActions, CardContent, CardMedia, CircularProgress, Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import { FitnessCenter, Forward } from '@mui/icons-material'
import axiosInstance from '../../utils/axiosInstance';

const Challenges = () => {
  const [challenges, setChallenges] = useState([{
    challenge_id: '',
    title: '',
    description: '',
    category: '',
    points: '',
    duration: '',
    difficulty: '',
    penalty: '',
    img_url: '',
    createdAt: ''
  }]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getChallenges = async () => {
      setLoading(true);

      await axiosInstance.get(`challenges/all`).then((response) => {

        setLoading(false);
        setChallenges(response.data.data);
      }).catch((error) => {
        setLoading(false);
        if (error.response && error.response.data.message === "No challenges found") {
          setChallenges([]);
        } else if (error.response && error.response.data.message !== "No challenges found") {
          setChallenges([]);
        } else {
          setChallenges([]);
        }
      });
    }

    getChallenges();
  }, []);

  return (
    <>
      <Header title="Challenge world" image={HeaderImage}>
        Lorem ipsum dolor sit amet consecteturrepellendus
        vero esse perspiciatis deserunt soluta, omnis nam error rem eaque quia recusandae aut?
      </Header>
      <div className='container flex items-center mt-10 text-3xl text-white gap-4'>
        <span className='bg-[#24245c] p-3 rounded-3xl px-5'><FitnessCenter className='text-[#c7b262] text-[3rem]' /></span>
        <span className='text-[2.4rem]'>GYM Challenges</span>
      </div>
      {loading ?
        <div className="flex justify-center items-center pt-20"><CircularProgress /></div>
      :
        <section className='trainers mt-12'>
          <div className="container trainers__container">
            {challenges.length > 0 ?
              challenges.map((challenge, index) => (
                <Card key={index} className='w-full'>
                  <CardMedia sx={{ height: 220 }} image={challenge.img_url} title={challenge.title} />
                  <CardContent>
                    <Typography variant="h5" className="text-green-600">
                      {challenge.title}
                    </Typography>
                    <Typography variant="body2" color="primary">
                      {challenge.description}
                    </Typography>
                    <CardActions>
                      <Link to={`/challenges/challenge/${challenge.challenge_id}`} className='text-[#c7b262] hover:text-[#494121]'>
                        Participate in {challenge.title} <Forward />
                      </Link>
                    </CardActions>
                  </CardContent>
                </Card>
              ))
              :
              <div className="w-full text-red-500 font-bold text-center text-xl">Challenges not created yet</div>
            }
          </div>
        </section>
      }
    </>
  )
}

export default Challenges